import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import AttachmentForm from './form';
import * as attachmentsActions from '../../attachments/actions';
import * as commonActions from '../../../common/actions';
import '../addEntityModal.css';

import {
  PENDING_PROCESSING_DOCUMENT_STATUS_ID,
  PROCESSING_COMPLETE_DOCUMENT_STATUS_ID
} from '../../../../lib/appConstants';
import { FaExclamationCircle } from 'react-icons/fa';
import swal from 'sweetalert2';

class AddAttachment extends Component {
  submitAttachment = (values) => {
    const { projectId, insuredId, filedOnly=false } = this.props;

    const serializedObj = {
      ...values,
      projectId: values.projectId ? values.projectId.value : undefined,
      ...(projectId && { projectId }),
      ...(insuredId && { insuredId: insuredId, subcontractorId: insuredId }),
      ...(filedOnly && { filedOnly: filedOnly }),
      documentStatusId: filedOnly ? PROCESSING_COMPLETE_DOCUMENT_STATUS_ID : PENDING_PROCESSING_DOCUMENT_STATUS_ID
    };

    let methodAction = '';
    if (projectId) {
      methodAction = 'sendProjectAttachment';
    } else if (insuredId) {
      methodAction = 'sendInsuredAttachment';
    }

    this.props.actions[methodAction](serializedObj, (success) => {
      if (success) {
        // this.props.close(true); 
        swal({
          type: "success",
          text: "The document was attached successfully.",
          confirmButtonText: "OK",
          confirmButtonColor: "#2E5965",
          allowOutsideClick: true,
        }).then(() => {
          window.location.reload();
        });
      }
    });
  };

  hideModal = () => {
    const { onHide, close } = this.props;
    if (onHide) onHide();
    else close();
  }

  render() {
    const {
      title,
      noteText
    } = this.props.local.strings.attachments.list.addModal;

    return (
      <div className="add-item-view add-entity-form-small">
        <div className="add-item-header">
          <h1>{title}</h1>
          {
            this.props.filedOnly && (
              <div className='add-item-note'>
                <FaExclamationCircle  className="warning-icon" />
                <p>{noteText}</p>
              </div>
            )
          }
        </div>

        <section className="white-section">
          <div className="add-item-form-subsection">
            <AttachmentForm
              close={this.hideModal}
              onSubmit={this.submitAttachment}
              insuredId={this.props.insuredId}
            />
          </div>
        </section>
      </div>
    );
  }
};

const mapStateToProps = (state) => {
  return {
    local: state.localization,
    common: state.common,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    actions: bindActionCreators(attachmentsActions, dispatch),
    commonActions: bindActionCreators(commonActions, dispatch)
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AddAttachment);
